import RouterHistory from '../../Components/Routes/RouterHistory';
import NotificationActions from '../../Actions/NotificationActions';
import Browser from '../../Utilities/Browser';
import Configuration from './Configuration';
import { getAppNameFromPath } from '../../Utilities/PathUtilities';
import { rg4js } from './RaygunSetup';

if(Configuration.isProductionBuild) {
    Browser.window.addEventListener("unhandledrejection", event => {
        const reason = event.reason;

        const error = reason instanceof Error
            ? reason
            : new Error(reason);

        rg4js('send', error);
    });
}

Browser.document.addEventListener('click', event => {
    if(['A', 'BUTTON'].indexOf(event.target.tagName) > -1 && event.target.classList.contains('goback')) {
        setTimeout( () => {
        if(Browser.window.history.length) {
            Browser.window.history.back();
            event.preventDefault();
            return;
        }}, 200);
    }
});

Browser.document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey)
        return;

    let target = event.target;
    while(target.tagName !== 'A') {
        target = target.parentNode;
        if(target == null)
            return;
    }

    if(target.target === "_blank")
        return;

    const path = target.pathname;
    const appPathSegment = getAppNameFromPath(Configuration.basePath, target.pathname);
    if(path.startsWith(Configuration.basePath) && appPathSegment === Configuration.appName){
        event.preventDefault();
        NotificationActions.clearNotifications();
        RouterHistory.push(path, null);
        return false;
    }
});
